var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgLivestream = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 16,
    viewBox: "0 0 46 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 2C19.1228 3.73119 20 5.83644 20 8C20 10.1636 19.1228 12.2688 17.5 14",
    stroke: "#EF3D3D",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16 4C16.9789 5.19056 17.5 6.58004 17.5 8C17.5 9.41997 16.9789 10.8094 16 12",
    stroke: "#EF3D3D",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 2C2.87719 3.73119 2 5.83644 2 8C2 10.1636 2.87719 12.2688 4.5 14",
    stroke: "#EF3D3D",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.5 4C5.52105 5.19056 5 6.58004 5 8C5 9.41997 5.52105 10.8094 6.5 12",
    stroke: "#EF3D3D",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.84149 5.08173C9.75719 5.02953 9.66097 5.00134 9.56266 5.00005C9.46435 4.99875 9.36747 5.02439 9.2819 5.07436C9.19634 5.12432 9.12516 5.19681 9.07563 5.28443C9.02611 5.37205 9.00001 5.47166 9 5.57309V10.4263C8.99977 10.5278 9.02573 10.6276 9.0752 10.7154C9.12467 10.8031 9.19588 10.8757 9.28152 10.9257C9.36717 10.9758 9.46416 11.0014 9.56257 10.9999C9.66097 10.9985 9.75723 10.9701 9.84149 10.9177L13.7304 8.49145C13.8126 8.44052 13.8807 8.36849 13.9279 8.28239C13.9752 8.19628 14 8.09903 14 8.00009C14 7.90115 13.9752 7.80389 13.9279 7.71779C13.8807 7.63168 13.8126 7.55966 13.7304 7.50873L9.84149 5.08173Z",
    fill: "#EF3D3D"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M31 8V2",
    stroke: "#EF3D3D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M34 2V3.74024C34.0121 5.28986 34.5403 6.79028 35.4993 8C36.4595 6.79082 36.9882 5.29015 37 3.74024V2",
    stroke: "#EF3D3D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M24 2V6.70799C24.03 7.07686 24.2044 7.41903 24.4853 7.66027C24.7663 7.90151 25.1311 8.02236 25.5007 7.99658H27",
    stroke: "#EF3D3D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M43.2546 8.29851H41.5812C41.1507 8.30871 40.7325 8.18645 40.4185 7.95856C40.1045 7.73068 39.9201 7.41578 39.906 7.08295V3.43625C39.9201 3.10342 40.1045 2.78852 40.4185 2.56063C40.7325 2.33274 41.1507 2.21049 41.5812 2.22068H43.2546",
    stroke: "#EF3D3D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M39.906 5.25989H42.7764",
    stroke: "#EF3D3D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M25.2887 11.4094H26.0256C26.0149 10.7614 25.4822 10.3139 24.6726 10.3139C23.8754 10.3139 23.2912 10.7543 23.2947 11.4148C23.293 11.951 23.6712 12.2582 24.2855 12.4055L24.6815 12.505C25.0774 12.6009 25.2976 12.7145 25.2994 12.9595C25.2976 13.2259 25.0455 13.407 24.6548 13.407C24.2553 13.407 23.9677 13.2223 23.9428 12.8583H23.1989C23.2184 13.6449 23.7812 14.0515 24.6637 14.0515C25.5515 14.0515 26.0735 13.6271 26.0753 12.9613C26.0735 12.3558 25.6172 12.0344 24.9851 11.8924L24.6584 11.8143C24.3423 11.7415 24.0778 11.6243 24.0831 11.3633C24.0831 11.1289 24.2908 10.9567 24.6673 10.9567C25.0348 10.9567 25.2603 11.1236 25.2887 11.4094ZM26.4539 10.9975H27.5672V14H28.3271V10.9975H29.4404V10.3636H26.4539V10.9975ZM29.9323 14H30.7011V12.7109H31.2622L31.9511 14H32.7998L32.0274 12.5866C32.4411 12.4091 32.6702 12.0487 32.6702 11.5515C32.6702 10.8288 32.1926 10.3636 31.3669 10.3636H29.9323V14ZM30.7011 12.093V10.9922H31.2195C31.6634 10.9922 31.8783 11.1893 31.8783 11.5515C31.8783 11.9119 31.6634 12.093 31.2231 12.093H30.7011ZM33.2135 14H35.6709V13.3661H33.9823V12.4979H35.5377V11.864H33.9823V10.9975H35.6638V10.3636H33.2135V14ZM36.9018 14L37.1717 13.1708H38.4838L38.7537 14H39.5776L38.324 10.3636H37.3333L36.0779 14H36.9018ZM37.367 12.5707L37.8145 11.1946H37.8429L38.2903 12.5707H37.367ZM40.0153 10.3636V14H40.761V11.6243H40.7912L41.7322 13.9822H42.2401L43.1811 11.6332H43.2113V14H43.957V10.3636H43.0089L42.0075 12.8068H41.9648L40.9634 10.3636H40.0153Z",
    fill: "#EF3D3D"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgLivestream);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/livestream.111065be549a2a778cbf76ec4a5c49ce.svg";